var _ref2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPhone = function SvgPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 25,
      height: 24,
      viewBox: "0 0 25 24",
      fill: "none",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.1 4.01758C5.666 4.01758 4.5 5.18358 4.5 6.61758C4.5 14.0056 10.511 20.0176 17.9 20.0176C19.333 20.0176 20.5 18.8516 20.5 17.4176C20.5 17.3066 20.493 17.1976 20.479 17.0896L15.859 16.0296C15.767 16.2056 15.666 16.3966 15.574 16.5746C15.118 17.4446 14.788 18.0766 13.946 17.7376C10.64 16.5776 7.941 13.8776 6.766 10.5316C6.409 9.74658 7.089 9.39058 7.951 8.94058C8.126 8.84858 8.315 8.74958 8.488 8.65958L7.428 4.03858C7.317 4.02458 7.209 4.01758 7.1 4.01758ZM17.9 22.0176C9.408 22.0176 2.5 15.1096 2.5 6.61758C2.5 4.08058 4.563 2.01758 7.1 2.01758C7.36 2.01758 7.617 2.03958 7.866 2.08258C8.109 2.12158 8.353 2.18358 8.591 2.26558C8.916 2.37858 9.161 2.65158 9.238 2.98758L10.607 8.95158C10.683 9.27958 10.588 9.62358 10.354 9.86758C10.218 10.0096 10.215 10.0126 8.975 10.6616C9.979 12.8356 11.724 14.5746 13.854 15.5446C14.504 14.3036 14.508 14.2996 14.65 14.1636C14.894 13.9296 15.24 13.8386 15.566 13.9106L21.531 15.2796C21.866 15.3566 22.139 15.6006 22.251 15.9256C22.333 16.1616 22.395 16.4056 22.436 16.6566C22.478 16.9036 22.5 17.1596 22.5 17.4176C22.5 19.9546 20.436 22.0176 17.9 22.0176Z",
      fill: "#041F47"
    })))
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgPhone, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/phone.6ade4f00.svg";
export { ForwardRef as ReactComponent };